<template>
    <base-layout v-if="detail.data.id" :theme="detail.data.theme">
        <template slot="sidebar">
            <space-sidebar :space="detail.data" class="sidebar-content hide-scroll-bar"/>
        </template>

        <div class="column is-paddingless scroll has-background-light">
            <div class="content-section">
                <div class="is-clearfix">
                    <h1 class="title is-pulled-left">
                        Milestones
                    </h1>

                    <user-avatar class="is-pulled-right"/>
                    <base-button
                        @click="show_create_modal = true"
                        icon="fas fa-plus"
                        class="is-link is-outlined is-pulled-right create-button"
                        text="Create milestone"/>
                </div><br/>

                <div class="is-clearfix"></div>

                <milestones-list :space="detail.data"/>
            </div>
        </div>

        <milestone-create-modal
            :space="detail.data"
            :visible="show_create_modal"
            @close="show_create_modal = false"/>
    </base-layout>

    <h1 v-else class="loader-container has-text-centered">
        <span class="loader is-inline-flex"></span>
    </h1>
</template>

<script>
import { mapState } from 'vuex';
import MilestoneCreateModal from '../components/milestones/MilestoneCreateModal.vue';
import MilestonesList from '../components/milestones/MilestonesList.vue';
import SpaceSidebar from '../components/space/SpaceSidebar.vue';
import BaseLayout from '../components/layouts/BaseLayout.vue';
import UserAvatar from '../components/user/UserAvatar.vue';
import { set_title } from '../utils/helpers';

export default {
    name: 'SpacesMilestones',
    components: {
        MilestoneCreateModal,
        MilestonesList,
        SpaceSidebar,
        UserAvatar,
        BaseLayout,
    },
    computed: mapState('spaces', ['detail']),
    data() {
        return { show_create_modal: false };
    },
    watch: {
        $route: {
            immediate: true,
            handler() {
                this.$store.commit('spaces/set_last_page', {
                    space_id: this.$route.params.space,
                    url: this.$route.fullPath,
                });
            },
        },
    },
    async created() {
        const space_id = this.$route.params.space;
        await this.$store.dispatch('spaces/detail', { space_id });
        set_title(this.detail.data.name);
    },
};

</script>

<style scoped>
    .create-button {
        margin-right: 1rem;
    }
</style>
